import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router'; 
import { KeycloakAuthService } from '../../services/keycloack.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { CommonModule } from '@angular/common';

export interface InterfaceComponentLinksMenu<URLs = string> {
  url: URLs;
  title: string;
}

@Component({
  selector: 'ui-header',
  standalone: true,
  imports: [MatMenuModule, RouterModule, CommonModule], 
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  private keycloakAuthService=inject(KeycloakAuthService);
  @Input() links?: InterfaceComponentLinksMenu[] | null = [];

  userEmail$: Observable<string>=this.keycloakAuthService.getUserProfile().pipe(
    map(profile => profile.email || 'No Email'),
    catchError(err => {
      console.error('Failed to get user profile', err);
      return of('Error fetching email');
    })
  );


  logOut() {
    this.keycloakAuthService.logout();
  }
}
